import getOwners from "./get-owners";
import getRentals from "./get-rentals";
import getBookings from "./get-bookings";
import getMappedRentals from "./get-mapped-rentals";
import getMappedOwners from "./get-mapped-owners";
import updateRentals from "./update-rentals";
import updateRental from "./update-rental";
import updateBooking from "./update-booking";
import updateInvoiceStatus from "./update-invoice-status";
import updateInvoice from "./edit-invoice";
import sendInvoice from "./send-invoice";
import getInvoice from "./get-invoice";
import getInvoicePermalink from "./get-invoice-permalink";
import resetInvoice from "./reset-invoice";
import getSettings from "./get-settings";
import updateSettings from "./update-settings";

export default {
    getOwners,
    getRentals,
    getBookings,
    getMappedRentals,
    getMappedOwners,
    updateRentals,
    updateRental,
    updateBooking,
    updateInvoiceStatus,
    updateInvoice,
    sendInvoice,
    getInvoice,
    getInvoicePermalink,
    resetInvoice,
    getSettings,
    updateSettings
}



// WEBPACK FOOTER //
// ./src/app/services/superconciergerie/index.js